import {ResourceType} from 'common/report/constants';

import type {PropertyItem} from '../query-block/properties-menu/types';

/** Validates the given property is eligible to be ephemerally mapped to a lookup table.
 * Returns an error string, or null if the prop can be mapped.
 *
 * Note that we do allow overriding a saved lookup table mapping
 */
export function propIneligibleForMappingReason(
  prop: Omit<PropertyItem, 'label'> | EmptyObj,
  temp = false,
): string | null {
  if (!prop?.resourceType) {
    return `Cannot map this property: only Event and User Properties are supported`;
  }

  let error = null;
  if (![ResourceType.User, ResourceType.Event].includes(prop.resourceType)) {
    error = `Cannot map this property: only Event and User Properties are supported`;
  } else if (temp && (prop.customProperty || prop.customPropertyId)) {
    // TODO(j) enable this for ephemeral query builder mappings (temp) too
    error = `Cannot map this property: custom properties are not yet supported`;
  } else if (Array.isArray(prop.value)) {
    error = `Cannot map a lookup table property to another lookup table`;
  } else if (temp && prop.tempDataGroupId) {
    error = `Cannot map this property: already temporarily mapped. Please first remove the temporary mapping.`;
  } else if (!temp && (prop.dataGroupId || prop.dimensionDataGroupId) && prop.joinPropertyType) {
    error = `Cannot map this property: already mapped. Please first remove the mapping.`;
  } else if (prop.dataGroupId && !prop.joinPropertyType) {
    error = `Cannot map this property: non-User profiles are not supported`;
  }
  return error;
}
